import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Tooltip } from "antd";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

const STALE_AFTER_MS = 5 * 60 * 1000;

// Greys out a trade's current rate once AutoTrader stopped sending live rates
// (bot or gateway down). Trades the bot doesn't track have no lastLiveRateUpdate
// and render as is.
const LiveRateFreshness = ({ lastLiveRateUpdate, children }) => {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    if (!lastLiveRateUpdate) return undefined;
    const interval = setInterval(() => setNow(Date.now()), 30 * 1000);
    return () => clearInterval(interval);
  }, [lastLiveRateUpdate]);

  if (!lastLiveRateUpdate) return children;
  const isStale = now - new Date(lastLiveRateUpdate).getTime() > STALE_AFTER_MS;
  if (!isStale) return children;

  return (
    <Tooltip title={`Last live update ${dayjs(lastLiveRateUpdate).fromNow()}`}>
      <div className="opacity-50">{children}</div>
    </Tooltip>
  );
};

LiveRateFreshness.propTypes = {
  lastLiveRateUpdate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date),
  ]),
  children: PropTypes.node,
};

export default LiveRateFreshness;
